import { create } from 'zustand';

interface FilterState {
  selectedMonth: string;
  selectedCardType: string;
  selectedCategoryId: string;
  searchQuery: string;
}

interface FilterActions {
  setSelectedMonth: (month: string) => void;
  setSelectedCardType: (cardType: string) => void;
  setSelectedCategoryId: (categoryId: string) => void;
  setSearchQuery: (query: string) => void;
  resetFilters: () => void;
}

export type FilterStore = FilterState & FilterActions;

const initialState: FilterState = {
  selectedMonth: '',
  selectedCardType: '',
  selectedCategoryId: '',
  searchQuery: '',
};

export const useFilterStore = create<FilterStore>()((set) => ({
  ...initialState,

  setSelectedMonth: (month) => set({ selectedMonth: month }),
  setSelectedCardType: (cardType) => set({ selectedCardType: cardType }),
  setSelectedCategoryId: (categoryId) =>
    set({ selectedCategoryId: categoryId }),
  setSearchQuery: (query) => set({ searchQuery: query }),
  resetFilters: () => set(initialState),
}));
